<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2021-04-21 08:45:51
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-09-06 09:31:57
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  computed: {
    key() {
      return this.$route.fullPath
    },
  },
}
</script>
